import React from 'react';
import { trackClick } from '../utils/segment';
import {Menu as GrommetMenu} from 'grommet';
import { lowercase, snakeCase } from '../utils/string';

// just a wrapper around Grommet's Button, but with logging capability
const Menu = ({
    items,
    event,
    nested,
    ...props
}) => {
    const {section: rawSection, element: rawElement, ...attrs} = event || {};
    const element = snakeCase(lowercase(rawElement || ''));
    const section = snakeCase(lowercase(rawSection || ''));

    const addLoggingToItem = ({onClick, event: itemEvent, ...rest}) => {
        const {section: itemRawSection, element: itemRawElement, ...attrs} = itemEvent || {};
        const itemElement = snakeCase(lowercase(itemRawElement || ''));
        const itemSection = snakeCase(lowercase(itemRawSection || ''));
        const onButtonClick = e => {
            trackClick({
                itemSection,
                itemElement,
                ...attrs
            });
            onClick && onClick(e);
        }
        return {...rest, onClick: onButtonClick};
    }
    
    const itemsWithLogging = nested ? (items || []).map(i => i.map(addLoggingToItem)) : (items || []).map(addLoggingToItem);

    return (
        <GrommetMenu 
            items={itemsWithLogging}
            onClick={() => trackClick({
                section,
                element,
                ...attrs
            })}
            data-event-section={section || undefined} 
            data-event-element={element || undefined}
            {...props} />
    );
} 

export default Menu;